(function($) {

    
    $('.fadebox').each(function(){
        var 
            contentTmpl = '<div class="fadebox-content"></div>',
            readmoreTmpl = '<div class="fadebox-more"><button type="button" class="btn btn-dark shadow fadebox-btn"><i class="material-icons">expand_more</i></button></div>',
            $el = {
                box: $(this),
                content: null,
                bar : null,
                btn : null
            },
            options = $.extend({
                always: true,
                maxHeight : '150'
            }, $el.box.data()),
            height = $el.box.outerHeight(),
            getFadeboxElements= function(){
                $el.content = $el.box.find('.fadebox-content');
                $el.bar = $el.box.find('.fadebox-more');
                $el.btn = $el.bar.find('.fadebox-btn');
            },
            fadeboxBulid=function(){
                $el.box.wrapInner(contentTmpl);
                $el.box.append(readmoreTmpl);
                getFadeboxElements($el);
            },
            click = function(e){
                e.stopPropagation();
                $el.box.css({
                //   height: $el.box.height(),
                  'max-height': '9999px'
                });
                // .animate({
                //   'height': height
                // });                
                $el.bar.fadeOut();
            };
        if(!$el.box.hasClass('no-collaps') && (options.always || options.maxHeight < height)){
            getFadeboxElements($el);       
            if($el.content.length == 0){
                fadeboxBulid($el);
            }
            $el.box.css({
                'max-height': options.maxHeight + 'px'
            })
            .addClass('fadebox-collapsed');
            $el.btn.click(click);           
        }
    });

})(jQuery);